import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

import { LeavePageConfirmDialog } from '../leave-page-confirm-dialog/leave-page-confirm-dialog'
import { BackToHomeButton } from './back-to-home-button'
import { SubmitButton } from './subnit-button'
import { useProcessDocumentTopBar } from './use-process-document-top-bar'

export const ProcessDocumentTopBar = () => {
  const {
    isOpenLeavePageConfirmDialog,
    isInReviewPage,
    isFirstTaskItem,
    isLastTaskItem,
    isAllTaskReviewed,
    isSubmittingOCRTasks,
    handleClickBackToHomeButton,
    handleChangeOpenLeavePageConfirmDialog,
    handleClickLeavePageConfirmDialogCancelButton,
    handleClickLeavePageConfirmDialogOkButton,
    handleClickPreviousTaskButton,
    handleClickNextTaskButton,
    handleClickSubmitButton,
  } = useProcessDocumentTopBar()

  return (
    <>
      <div className={cn('flex items-center', 'h-fit', 'py-[28px] pl-[18px] pr-[30px]')}>
        <div className={cn('flex items-center')}>
          <BackToHomeButton onClick={handleClickBackToHomeButton} />
          <span className={cn('block', 'w-[1px]', 'h-[18px]', 'bg-black', 'ml-2.5 mr-4')} />
          <h1 className={cn('text-sm font-semibold text-slate-900')}>Upload Documents Scan</h1>
        </div>

        {isInReviewPage && (
          <div className={cn('flex gap-x-3', 'ml-auto')}>
            <Button
              type="button"
              variant="secondary"
              className={cn('w-[120px]', 'text-blue-600')}
              disabled={isFirstTaskItem}
              onClick={handleClickPreviousTaskButton}
            >
              Previous
            </Button>
            <Button
              type="button"
              variant="secondary"
              disabled={isLastTaskItem}
              className={cn('w-[120px]', 'text-blue-600')}
              onClick={handleClickNextTaskButton}
            >
              Next
            </Button>
            <SubmitButton
              disabled={!isAllTaskReviewed}
              loading={isSubmittingOCRTasks}
              onClick={handleClickSubmitButton}
            />
          </div>
        )}
      </div>

      <LeavePageConfirmDialog
        open={isOpenLeavePageConfirmDialog}
        onChangeOpen={handleChangeOpenLeavePageConfirmDialog}
        onClickCancelButton={handleClickLeavePageConfirmDialogCancelButton}
        onClickOkButton={handleClickLeavePageConfirmDialogOkButton}
      />
    </>
  )
}
